/**
 * @file
 * Custom scripts.
 */

(function ($, Drupal, drupalSettings) {

  'use strict';

  // Check if JS is active

  Drupal.behaviors.checkJS = {
    attach: function (context, settings) {

      $(once('checkJS', 'body', context)).each(function() {

        $(this).removeClass('no-js');
      });
    }
  }

  // Remove autocomplete from hidden search field

  Drupal.behaviors.removeAutocomplete = {
    attach: function (context, settings) {

      $(once('removeAutocomplete', '#custom-search-block-form input[type=hidden]', context)).each(function() {

        $(this).removeAttr('autocomplete');
      });
    }
  }

  // Add class to archive summary to deal with the lack of :has() support on mobile FF

  Drupal.behaviors.archivesSummaryCSS = {
    attach: function (context, settings) {

      $(once('archivesSummaryCSS', '.view .view-content', context)).each(function() {

        if ($(this).find('.views-summary').length > 0)
        {
          $(this).css('overflow-x', 'visible');
        }
      });
    }
  }
  
  // Custom accordion in nodes

  Drupal.behaviors.customAccordionLinks = {
    attach: function (context, settings) {

      $(once('customAccordionLinks', 'h2.accordion-title', context)).each(function() {

        $(this).wrapInner('<a class="accordion-title__link" href="#" aria-expanded="false"></a>');

        $(this).on('click', function(event) {
          event.preventDefault();
        });
      });

      $(once('customAccordionLinks', '.accordion-file-link', context)).each(function() {

        $(this).on('click', function(event) {
          event.preventDefault();
        });
      });
    }
  }

  Drupal.behaviors.customAccordion = {
    attach: function (context, settings) {

      // open saved accordions on load

      var page = $('article').attr('data-url');
      var op_ac = $.session.get(page)

      if (typeof op_ac !== 'undefined')
      {
        var index;
        var op_ac = op_ac.split(',');

        for (index = 0; index < op_ac.length; ++index) {
          $('.accordion-title', context).eq(op_ac[index] - 1).addClass('accordion-title--opened accordion-title--opened--noline');
          $('.accordion', context).eq(op_ac[index] - 1).show();
        }
      }

      // open and save opened accordions on click

      $(once('customAccordion', '.accordion-title', context)).each(function () {

        $(this).on('click', function() {

          if ($(this).next().is(":hidden"))
          {
            $(this).next().slideDown();
            $(this).addClass('accordion-title--opened accordion-title--opened--noline');
            $(this).find('a').attr('aria-expanded', 'true');
          }
          else
          {
            $(this).next().slideUp(function() {
              $(this).prev().removeClass('accordion-title--opened--noline');
            });
            $(this).removeClass('accordion-title--opened');
            $(this).find('a').attr('aria-expanded', 'false');
          }
          
          var accordions_no = [];

          $('.node .accordion-title--opened').each(function() {

            accordions_no.push($(this).index('.accordion-title') + 1);
          });

          // save only accordions in nodes

          if ($(this).parents('.node').length > 0) $.session.set(page, accordions_no.join(','));
        });
      });
    }
  }

  Drupal.behaviors.fileDetailsAccordion = {
    attach: function (context, settings) {

      // open file details accordions on click

      $(once('fileDetailsAccordion', '#main', context)).each(function () {

        $('.accordion-file-link').on('click', function() {

          var filesize = $(this).attr('data-filesize');
          var author = $(this).attr('data-file-author');

          if (author == '' || typeof author === 'undefined')
          {
            if ($('.metrics-author').length > 0)
            {
              author = $('.metrics-author').text();
            }
            else
            {
              author = '';
            }
          }

          var published_by = $(this).attr('data-published-by');
          var publish_date = $(this).attr('data-publish-date');

          var content = '';

          content += '<div class="file-details-accordion">';
          content += '<p><span>Metryka pliku</span></p>';
          content += '<ul class="no-bullets">';
          content += '<li><span>Rozmiar pliku:</span> ' + filesize + '</li>';

          if (!author.startsWith('Nazwiska w ') && author != '') content += '<li><span>Autor pliku:</span> ' + author + '</li>';

          content += '<li><span>Osoba publikująca:</span> ' + published_by + '</li>';
          content += '<li><span>Data przesłania pliku:</span> ' + publish_date + '</li>';
          content += '</ul>';
          content += '</div>';

          if ($(this).next('.file-details-accordion').length == 0)
          {
             $(content).insertAfter($(this));

             $(this).next().slideDown();
             $(this).addClass('accordion-title--opened');
             $(this).attr('aria-expanded', 'true');
          }
          else
          {
            $(this).next().slideUp(function() {
              $(this).remove();
            });
            $(this).removeClass('accordion-title--opened');
            $(this).attr('aria-expanded', 'false');
          }
        });
      });
    }
  }
  
})(jQuery, Drupal, drupalSettings);
